import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAccessToken, isTokenExpired } from '@utils/helpers';
import { useSelector } from 'react-redux';
import { RootState } from '@utils/types';

export const HomeRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const loungeId = searchParams.get('loungeId');
  const token = getAccessToken();
  const partnerSession = useSelector(
    (state: RootState) => state.partnerSession.partnerSession,
  );

  useEffect(() => {
    const isAuthenticated = token && !isTokenExpired(token);

    if (!isAuthenticated) {
      if (partnerSession?.city) {
        navigate(
          `/select-city?city=${encodeURIComponent(partnerSession.city)}`,
          { replace: true },
        );
        return;
      }

      navigate(
        loungeId ? `/login/phone?loungeId=${loungeId}` : '/login/phone',
        { replace: true },
      );
    } else if (loungeId) {
      // Always go through card-details first — /booking is only reachable
      // after a successful eligibility check, even for authenticated users.
      navigate(`/card-details/${loungeId}`, { replace: true });
    } else if (partnerSession?.city) {
      navigate(`/select-city?city=${encodeURIComponent(partnerSession.city)}`, {
        replace: true,
      });
    } else {
      navigate('/select-city', { replace: true });
    }
  }, [navigate, loungeId, token, partnerSession]);

  return null;
};
